export enum ButtonPlacementEnum {
    START_MESSAGE = 'start_message',
    TOP_MESSAGE = 'top_message',
}

export const ButtonPlacementLabels = {
    [ButtonPlacementEnum.START_MESSAGE]: 'Mensagem inicial',
    [ButtonPlacementEnum.TOP_MESSAGE]: 'Junto aos planos',
}